import { createContext } from 'react';

const LastWakeContext = createContext();

export default LastWakeContext;
